import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from '@/locales/date-time-formats'
import numberFormats from '@/locales/number-formats'

import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'

Vue.use(VueI18n)

function loadBrowserLanguage() {
  const language = navigator.language.split('-')[0]
  if (language === 'en') return language
  else if (language === 'es') return language
  else return 'en'
}

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  const vuetifyLocales = { en, es }
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      const $vuetify = Object.assign(
        {},
        vuetifyLocales[locale],
        locales(key).$vuetify
      )
      messages[locale] = { ...locales(key), $vuetify }
    }
  })
  return messages
}

export default new VueI18n({
  locale: loadBrowserLanguage(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats,
  numberFormats,
})
